module.exports = __webpack_public_path__ + "static/sign-883b14c662a54d3c337cf9a1a2b55fb5.jpg";